import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import * as RadixToggleGroup from "@radix-ui/react-toggle-group";
import { useToggleGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ToggleGroup.module.scss";
import type { BaseToggleGroupItem, ToggleGroupComponentProps } from "./types";

const COMPONENT_KEY = CoreUiComponents.ToggleGroup;
export const ToggleGroup = <Item extends BaseToggleGroupItem>({
  className,
  children,
  items,
  render,
  orientation = "horizontal",
  ref,
  ...restProps
}: ToggleGroupComponentProps<Item>) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY, [orientation]);

  const { isSelected, props } = useToggleGroup({
    items,
    render,
    ...restProps,
  });

  return (
    <RadixToggleGroup.Root
      className={clsx(block, "ToggleGroup", className)}
      {...restProps}
      ref={ref}
      {...props}
    >
      {items.map((item) => (
        <RadixToggleGroup.Item
          className={cn("item")}
          key={item.id}
          value={item.id}
          aria-label={item.ariaLabel}
        >
          {render({ item, selected: isSelected(item) })}
        </RadixToggleGroup.Item>
      ))}
    </RadixToggleGroup.Root>
  );
};
